import { useEffect, useState } from "react";
import { useApp } from "../../hooks/AppProvider";
import { InputCell, Table, EditDeleteCell, NewRowTemplate } from "../../components/BasicComponents";

function RoleTable({ roles, onModify, onDelete, onAdd }) {    
    return (
        <>
        <Table headers={["Nom du rôle", "Quota", "Élève assigné", ""]}>
            {roles.map((data) => (
                <RoleRow
                    key={data.id}
                    id={data.id}
                    name={data.name}
                    quota={data.quota}
                    students={data.students}
                    onModify={onModify}
                    onDelete={onDelete}
                />
            ))}
            <NewRow onAdd={onAdd} />
        </Table>
        </>
    );
}

function RoleRow({ id, name, quota, students, onModify, onDelete }) {
    let app = useApp();

    let [change, setChange] = useState(false);
    let [name0, setName0] = useState(name);
    let [quota0, setQuota0] = useState(quota);

    function submitChange(e) {        
        if(app.emptyCheck(name0)) {
            return alert("Le nom est vide");
        }

        if(app.emptyCheck(quota0) || quota0 < 1) {
            return alert("Le quota est invalide");
        }

        onModify(id, name0, quota0);
        setChange(false);
    }

    function del() {
        if(window.confirm("Vous êtes sur le point de supprimer le rôle: " + name + ". Souhaitez-vous continuer ?")) {
            onDelete(id);
        }
    }

    return (
        <>
            <tr>
                <InputCell value={name0} onChange={e => { setName0(e.target.value); setChange(true) }} placeholder="Nom du rôle" />
                <InputCell type="number" min={1} placeholder="Quota du rôle" value={quota0} onChange={e => { setQuota0(e.target.value); setChange(true) }} />
                <td>
                    <Table headers={[]}> 
                        {students.length==0 ? (<tr><td>Aucun élève assigné.e</td></tr>) : students.map(data => (<tr><td>{data}</td></tr>))}
                    </Table>
                </td>

                <EditDeleteCell onEdit={submitChange} onDelete={del} change={change} />
            </tr>
        </>
    );
}

function NewRow({ onAdd }) {
    let [newName, setNewName] = useState("");
    let [newQuota, setNewQuota] = useState(1);

    function add() {
        if(newName.trim() === "") {
            return alert("Le nom du rôle ne peut pas être vide.");
        }
        if(newQuota < 1) {
            return alert("Le quota doit être au moins 1.");
        }

        onAdd(newName, newQuota, data => {
            setNewName("");
            setNewQuota(1);
        });
    }

    return (
       <NewRowTemplate>
            <InputCell value={newName} onChange={(e) => { setNewName(e.target.value); }} placeholder="Nom du rôle" />
            <InputCell type="number" min={1} placeholder="Quota du rôle" value={newQuota} onChange={(e) => { setNewQuota(e.target.value); }} />
            <td></td>
            <td>
                <button onClick={ add }>Ajouter</button>
            </td>
        </NewRowTemplate>
    );
}

function Role() {
    let app = useApp();

    let [roles, setRoles] = useState([]);
    let [update, setUpdate] = useState(0);
    let [quotas, setQuotas] = useState({student_count: 0, role_quota: 0, difference: 0});

    useEffect(() => {
        app.sendGet("/role/listmy", data => {
            setRoles(data);
        });

    }, [update]);   

     useEffect(() => {
        app.sendGet("/role/quotas", data => {
            setQuotas(data);
        });
    }, [roles]);

    function assign(e) {
        if(window.confirm("Attention: cette action va réattribuer un rôle à chaques élèves")) {
            app.sendGet("/role/assign", data => {
                if(data.success == false) {
                    return alert("Une erreur s'est produite")
                }
                
                app.navigate("/role-animation");
            });
        }
    }

    function onAdd(name, quota, callback = (data) => {}) {
        app.sendPost("/role/add", {name: name, quota: quota}, data => {
            if(data.success === false) {
                alert("Error: " + data.message);
                return;
            }
            setRoles([... roles, data]);
            callback(data);
        });
    }

    function onModify(id, name, quota) {
        app.sendPost("/role/update", {id: id, name: name, quota: quota}, data => {
            setUpdate(update + 1);
        });
    }

    function onDelete(id) {
        app.sendPost("/role/delete", {id: id}, data => {
            setUpdate(update + 1);
        });
    }

    function anim() {
        app.navigate("/role-animation");
    }

    return (
        <>
        <div>
            <h1>Mes rôles</h1>
            <RoleTable roles={roles} onModify={onModify} onDelete={onDelete} onAdd={onAdd} />
            <div style={{fontSize: "1.5em", marginTop: "1em"}}>
                <span className="error-text">
                    {quotas.difference < 0 && (<span>Il manque {-quotas.difference} place(s)</span>)}
                    {quotas.difference > 0 && (<span>Il y a {quotas.difference} place(s) en trop</span>)}
                </span>
                <div style={{textAlign: "center", display: "flex", justifyContent: "space-around"}}>
                    {quotas.difference == 0 && (
                        <>
                        <button onClick={assign}>Attribuer</button>
                        <button onClick={anim}>Rejouer l'animation</button>
                        
                        </>
                        )}
                </div>
            </div>
            
        </div>
        </>
    );
}

export default Role;